import { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { ArrowForward } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, IconButton, Typography } from "@mui/material";

import pages from "../../../constants/pages";
import { colors } from "../../css components/Style";
import { signInMember } from "../../../redux/slices/memberSlice";
import SelectRole from "./Form";

const Admin = styled.div`
  width: fit-content;
  border-radius: 8px;
  font-size: 10px;
  color: ${colors.green};
  // border: 1px solid ${colors.green};
  padding: 10px;
  background: white;
  display: flex;
  cursor: pointer;
`;

const Icon = styled(IconButton)`
  background: ${colors.purple} !important;
  color: #fff !important;
  height: 40px;
  width: 40px;
  margin: 0 5px;
  padding: 0 5px;

  &:hover {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }

  &[disabled] {
    background: #ccc !important;
    color: #888 !important;
    cursor: not-allowed;
    box-shadow: none !important;
    pointer-events: none;
  }
`;
const Card = styled(Box)`
  width: 100%;
  max-width: 400px;
  padding: 24px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 12px #376fd033;
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 16px #376fd055;
  }
`;

const Title = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
`;

const Description = styled(Typography)`
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
  line-height: 1.5;
`;

export default function AdminForm({ brands, businessEntityID, loadingBrands }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userID = sessionStorage.getItem("userID");
  const authToken = sessionStorage.getItem("authToken");
  const businessEntityId = sessionStorage.getItem("businessEntityId");

  const { dashboardState, activeBrand } = useSelector(
    (state) => state.memberDetails
  );

  const [currentBrand, setCurrentBrand] = useState({
    ID: activeBrand.ID,
    name: activeBrand.brandName,
    type: activeBrand.brandType,
    businessEntityID: activeBrand.bEntityID,
    admin: false,
  });

  const [userDashboardState, setUserDashboardState] = useState(
    dashboardState || "monetization"
  );

  const role =
    useSelector((state) => state?.memberDetails.role) ||
    sessionStorage.getItem("role");

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        background: "#F5F3F8",
        paddingTop: "60px", // optional
        paddingBottom: "60px", // optional
      }}
    >
      {/* <div
        style={{
          background: "#fff",
          padding: "25px 30px",
          borderRadius: "8px",
          width: "500px",
          boxShadow: "0 4px 18px rgba(0,0,0,0.10)",
        }}
      > */}
      <Card>
        <Title>
          {currentBrand.ID &&
            userDashboardState === "monetization" &&
            "Choose brand to continue"}
          {currentBrand.ID &&
            userDashboardState === "promotion" &&
            "Review Campaign Requests"}
          {!currentBrand.ID && "Continue as Admin"}
        </Title>
        <Description>
          {currentBrand.ID &&
            userDashboardState === "monetization" &&
            "Select the brand you want to access and manage its audience and campaigns"}
          {currentBrand.ID &&
            userDashboardState === "promotion" &&
            "  View all campaign requests submitted by brands and approve or reject them based on requirements."}
          {!currentBrand.ID &&
            "Continue as Admin to manage brands and campaigns."}
        </Description>

        <Grid container spacing={4}>
          <SelectRole
            role={role}
            userDashboardState={userDashboardState}
            authToken={authToken}
            setUserDashboardState={setUserDashboardState}
            currentBrand={currentBrand}
            setCurrentBrand={setCurrentBrand}
            brands={brands}
            businessEntityID={businessEntityID}
            userID={userID}
            component={"admin"}
            loadingBrands={loadingBrands}
          />
          <Grid
            size={12}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Admin
              style={{
                pointerEvents: currentBrand.ID && "none",
                color: currentBrand.ID && "#808080",
                borderColor: currentBrand.ID && "#808080",
              }}
              onClick={async () => {
                setCurrentBrand({
                  ID: "",
                  name: "",
                  type: "",
                  admin: !currentBrand.admin,
                });
                setUserDashboardState("");

                sessionStorage.removeItem("");
                sessionStorage.setItem("role", "SUPER_ADMIN");
                await dispatch(
                  signInMember({
                    authToken: authToken,
                    userID: userID,
                    businessEntityId: businessEntityId,
                  })
                );

                navigate(pages.accountVerification.route);
              }}
            >
              <Typography>Continue as Admin</Typography>
            </Admin>

            <Icon
              disabled={!currentBrand.ID}
              onClick={async () => {
                sessionStorage.setItem("ps", "SA");

                sessionStorage.setItem("role", "NORMAL_USER");
                localStorage.setItem(
                  "dashboardState" + currentBrand.ID,
                  userDashboardState
                );

                await dispatch(
                  signInMember({
                    authToken: authToken,
                    userID: userID,
                    businessEntityId: currentBrand.businessEntityID,
                    brandType: currentBrand.type,
                  })
                );
                navigate(pages.brandDetails.route);
              }}
            >
              <ArrowForward />
            </Icon>
          </Grid>

          <Grid size />
        </Grid>
      </Card>
    </div>
  );
}
